const chartId = "chart-14"
let Chart = require('chart.js');
Chart.defaults.global.defaultFontFamily = 'acumin-pro';
const colors = require('../../../colors');
const data = require('./data');
const _groupBy = require('lodash/groupBy')
const _each = require('lodash/each')
// const config = require('../../../config');
const colorNames = ['magenta', 'orange', 'blue', 'teal', 'lime', 'green'];

const full = [];
colorNames.forEach(function(name) {
  full.push(colors.secondary[name][100].rgba)
})
const eighty = [];
colorNames.forEach(function(name) {
  eighty.push(colors.secondary[name][80].rgba)
})

full.push("rgba(136,136,136,1)");
eighty.push("rgba(136,136,136,.8)")

const range = [62, 66.6, 70.9, 75.2, 79.5, 83.8, 88.1]
const labels = [
  range[0] + ' - ' + range[1],
  range[1] + ' - ' + range[2],
  range[2] + ' - ' + range[3],
  range[3] + ' - ' + range[4],
  range[4] + ' - ' + range[5],
  range[5] + ' - ' + range[6],
  "No Data"
]

const groupedData = _groupBy(data, function(row) {
  if (row.LE < range[1]) {
    return labels[0]
  } else if (row.LE >= range[1] && row.LE < range[2]) {
    return labels[1]
  } else if (row.LE >= range[2] && row.LE < range[3]) {
    return labels[2]
  } else if (row.LE >= range[3] && row.LE < range[4]) {
    return labels[3]
  } else if (row.LE >= range[4] && row.LE < range[5]) {
    return labels[4]
  } else if (row.LE >= range[5]) {
    return labels[5]
  } else {
    return labels[6]
  }

});

let hues = [
  colors.secondary["orange"][100].rgba,
  colors.secondary["orange"][60].rgba,
  colors.secondary["yellow"][100].rgba,
  colors.secondary["blue"][40].rgba,
  colors.secondary["blue"][60].rgba,
  colors.secondary["blue"][100].rgba,
  "rgba(136,136,136,1)"
]
let borders = hues.map(x => x.replace("1)", ".7)"));

let dataset = {
  label: 'Total Tracts',
  data: [],
  backgroundColor: hues,
  borderColor: borders,
  borderWidth: 1
}

_each(labels, function(label) {
  dataset.data.push(groupedData[label] ? groupedData[label].length : 0)
})
dataset.data[dataset.data.length - 1] = 46

let ctx = document.getElementById(chartId).getContext('2d');
new Chart(ctx, {
  type: 'bar',
  data: {
    labels: labels,
    datasets: [dataset]
  },
  options: {
    legend: {
      display: false
    },
    aspectRatio: window.innerWidth > 992 ? 5 : 3,
    onResize: function(chartObj) {
      chartObj.aspectRatio = window.innerWidth > 992 ? 5 : 3;
      chartObj.update()
    },
    scales: {
      yAxes: [{
        ticks: {
          beginAtZero: true
        }
      }]
    }
  }
})